<template>
  <div>
    <Navigation />
    <div class="wrap">
      <div class="head">
        <div><h1>Users &amp; Staff</h1><p class="lede">{{ users.length }} team member{{ users.length === 1 ? '' : 's' }}.</p></div>
        <button class="primary" @click="openNew">+ New User</button>
      </div>
      <div class="card">
        <table>
          <thead><tr><th>Name</th><th>Role</th><th>Email</th><th>Phone</th><th>Last login</th><th></th></tr></thead>
          <tbody>
            <tr v-for="u in users" :key="u.id">
              <td>{{ u.name }}</td>
              <td><span :class="'badge ' + u.role">{{ u.role }}</span></td>
              <td class="muted">{{ u.email || '—' }}</td>
              <td class="muted">{{ u.phone || '—' }}</td>
              <td class="muted small">{{ u.last_login_at || 'Never' }}</td>
              <td><button class="secondary small" @click="openSetPin(u)">Set PIN</button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div v-if="showNew" class="modal-back" @click.self="showNew=false">
      <div class="modal card">
        <h3>Add User</h3>
        <label>Name</label><input v-model="newUser.name" />
        <label>Role</label>
        <select v-model="newUser.role">
          <option value="cashier">Cashier</option>
          <option value="manager">Manager</option>
          <option value="waiter">Waiter (restaurant)</option>
          <option value="kitchen">Kitchen (restaurant)</option>
          <option value="stock_controller">Stock Controller</option>
          <option value="bookkeeper">Bookkeeper</option>
        </select>
        <label>Email (optional)</label><input v-model="newUser.email" type="email" />
        <label>Phone</label><input v-model="newUser.phone" placeholder="0712345678" />
        <label>Password (optional — needed if user will sign in via desktop)</label>
        <input v-model="newUser.password" type="password" minlength="8" />
        <div class="modal-actions">
          <button class="secondary" @click="showNew=false">Cancel</button>
          <button class="primary" @click="saveUser" :disabled="saving">{{ saving ? 'Saving…' : 'Save' }}</button>
        </div>
        <p class="err" v-if="err">{{ err }}</p>
      </div>
    </div>

    <div v-if="pinUser" class="modal-back" @click.self="pinUser=null">
      <div class="modal card">
        <h3>Set PIN for {{ pinUser.name }}</h3>
        <label>4–6 digit PIN</label>
        <input v-model="pinValue" type="password" inputmode="numeric" maxlength="6" />
        <div class="modal-actions">
          <button class="secondary" @click="pinUser=null">Cancel</button>
          <button class="primary" @click="savePin" :disabled="pinSaving">{{ pinSaving ? 'Saving…' : 'Save PIN' }}</button>
        </div>
        <p class="err" v-if="err">{{ err }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Navigation from '@/components/paysol-nav/Navigation.vue';
import { paysol, execute } from '@/api';

export default {
  name: 'UserManagement',
  components: { Navigation },
  data() {
    return {
      users: [],
      showNew: false, saving: false, err: '',
      newUser: { name: '', role: 'cashier', email: '', phone: '', password: '' },
      pinUser: null, pinValue: '', pinSaving: false,
    };
  },
  async mounted() { await this.load(); },
  methods: {
    async load() {
      const { data } = await execute({ function: 'getUsers' }, paysol);
      if (data.success) this.users = data.data;
    },
    openNew() {
      this.newUser = { name: '', role: 'cashier', email: '', phone: '', password: '' };
      this.err = ''; this.showNew = true;
    },
    async saveUser() {
      this.saving = true; this.err = '';
      try {
        const { data } = await execute({ function: 'createUser', ...this.newUser }, paysol);
        if (!data.success) { this.err = data.message; return; }
        this.showNew = false;
        await this.load();
      } catch (e) { this.err = e.response?.data?.message || 'Failed to create user.'; }
      finally { this.saving = false; }
    },
    openSetPin(u) { this.pinUser = u; this.pinValue = ''; this.err = ''; },
    async savePin() {
      this.pinSaving = true; this.err = '';
      try {
        const { data } = await execute({ function: 'setPin', userId: this.pinUser.id, pin: this.pinValue }, paysol);
        if (!data.success) { this.err = data.message; return; }
        this.pinUser = null;
      } catch (e) { this.err = e.response?.data?.message || 'Failed to set PIN.'; }
      finally { this.pinSaving = false; }
    }
  }
};
</script>

<style scoped>
.wrap { max-width: 1200px; margin: 0 auto; padding: 24px; }
.head { display: flex; justify-content: space-between; align-items: end; margin-bottom: 20px; }
h1 { font-size: 26px; margin: 0 0 4px; }
.lede { color: var(--paysol-muted); margin: 0; }
.muted { color: var(--paysol-muted); } .small { font-size: 11px; }
.modal-back { position: fixed; inset: 0; background: rgba(0,0,0,0.6); display: flex; align-items: center; justify-content: center; z-index: 50; padding: 24px; }
.modal { width: 100%; max-width: 460px; }
.modal-actions { display: flex; justify-content: flex-end; gap: 8px; margin-top: 20px; padding-top: 14px; border-top: 1px solid var(--paysol-line); }
button.small { padding: 4px 10px; font-size: 11px; }
.err { color: var(--paysol-danger); font-size: 12px; margin-top: 8px; }
</style>
